import { useContext } from "react";
import { GlobalDataContext } from "../../providers/GlobalDataProvider";
import { Link } from "react-router-dom";

export default function FooterSection() {
  const { state } = useContext(GlobalDataContext)

  const sections = [
    {
      title: "اطلاعات بیشتر",
      items: [
        { href: "/", text: "خانه" },
        { href: "/product?page=1", text: "همه آثار" },
        { href: "/capillary-guidance", text: "پیشنهاد هوشمند" },
        { href: "/categories", text: "دسته بندی" },
        { href: "/artists", text: "هنرمندان" },
        { href: "/blogs?page=1", text: "مجله هنری" },
        { href: "/favorite", text: "علاقه مندی ها" },
        { href: "/about-us#main", text: "درباره ما" },
        { href: "/contact#main", text: "تماس با ما" },
      ],
    },
  ];

  return (
    <footer className="bg-main  bg-gradient-to-t text-white py-8 pb-20 md:pb-8">
      <div className="container grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 sm:gap-8 gap-3 text-xs md:items-start px-4 sm:px-auto">
        <div
          className="text-gray-300 lg:col-span-2"
          dir="rtl"
        >
          <Link to="/" className="lg:w-[260px] lg:h-[126px] w-[130px] h-[63px] overflow-hidden centerOfParent">
            <img
              src="/images/Tonaliteh logo.png"
              width={100} height={100}
              style={{ width: '100%', height: 'auto' }} // optional
              alt="Tonaliteh"
              className="py-2 object-contain"
            />
          </Link>
          <p className="flex items-center mb-2">{state.address}</p>
          <p>تلفن: {state.phone}</p>
          <p>موبایل: {state.mobile}</p>
          <p>ایمیل: {state.email}</p>
        </div>

        {sections.map((section, index) => (
          <div dir="rtl" key={index}>
            <span className="text-lg font-bold mb-2">{section.title}</span>

            <ul className="space-y-2">
              {section.items.map((item, index) => (
                <li key={index}>
                  <Link
                    to={item.href}
                    className="text-gray-300 hover:text-gray-100"
                  >
                    {item.text}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div className="col-span-2 md:col-span-1 lg:col-span-2">
          <div className="centerOfParent space-x-4 text-2xl lg:text-4xl mb-4">
            <a
              href={state.instagram}
              target="_blank"
              rel="noreferrer"
              className="hover:text-gray-100"
              aria-label="اینستاگرام"
            >
              <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path></svg>
            </a>

            <a
              href={state.counseling_telegram}
              target="_blank"
              rel="noreferrer"
              className="hover:text-gray-100"
              aria-label="تلگرام"
            >
              <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 496 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm121.8 169.9l-40.7 191.8c-3 13.6-11.1 16.9-22.4 10.5l-62-45.7-29.9 28.8c-3.3 3.3-6.1 6.1-12.5 6.1l4.4-63.1 114.9-103.8c5-4.4-1.1-6.9-7.7-2.5l-142 89.4-61.2-19.1c-13.3-4.2-13.6-13.3 2.8-19.7l239.1-92.2c11.1-4 20.8 2.7 17.2 19.5z"></path></svg>
            </a>

            <a
              href={state.linkedin}
              target="_blank"
              rel="noreferrer"
              className="hover:text-gray-100"
              aria-label="لینکدین"
            >
              <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"></path></svg>
            </a>
          </div>

          <div className="flex items-center gap-2 justify-center">
            <div className="max-w-[120px]">
              <a
                aria-label="e nemad"
                target="_blank"
                href="https://trustseal.enamad.ir/?id=523685&Code=YVMZ6hDnPqpcEtaPqEkyvOE316j7rlnv"
              >
                <img width={100} height={100}
                  alt="اینماد"
                  id="QCC7fMUobFpELTgyJmeL"
                  data-lazy-src="https://seenart.ir/wp-content/uploads/2023/10/enamad-logo.png?id=375582&amp;Code=QCC7fMUobFpELTgyJmeL"
                  className="entered lazyloaded cursor-pointer"
                  src="https://seenart.ir/wp-content/uploads/2023/10/enamad-logo.png?id=375582&amp;Code=QCC7fMUobFpELTgyJmeL"
                  data-ll-status="loaded"
                />
                <noscript>
                  <img width={100} height={100}
                    alt="اینماد"
                    className="cursor-pointer"
                    src="https://seenart.ir/wp-content/uploads/2023/10/enamad-logo.png?id=375582&amp;Code=QCC7fMUobFpELTgyJmeL"
                    id="QCC7fMUobFpELTgyJmeL"
                  />
                </noscript>
              </a>
            </div>

            <div>
              <a href="#" title="درگاه پرداخت امن"
                aria-label="بیت پی">
                <img width={100} height={100} src="https://bitpay.ir/theme/public/images/trusted-logo.svg" alt="درگاه پرداخت بیت پی" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer >
  );
}
